/**
 * @param container:String/HTMLDivElement, opts:MapOptions
 */
function Mapmanager(container, opts) {
  let map = null
  // eslint-disable-next-line no-undef
  map = new AMap.Map(container, opts)
  this._map = map
}

Mapmanager.prototype.getMap = function () {
  return this._map
}
Mapmanager.prototype.showToolBar = function () {
  if (this._toolBar) {
    this._toolBar.show()
  } else {
    // eslint-disable-next-line no-undef
    var toolBar = new AMap.ToolBar({
      visible: true,
    })
    this._toolBar = toolBar
    this._map.addControl(toolBar)
  }
}
Mapmanager.prototype.setZoomAndCenter = function (zoom, position) {
  this._map.setZoomAndCenter(zoom, position)
}
Mapmanager.prototype.destroy = function () {
  if (this._map) {
    this._map.destroy()
  }
}

export default Mapmanager
